import mitt from 'mitt'

export const eventos = {
    buscaCabecalho: 'busca-cabecalho'
}

export const remove_eventos = [
    eventos.buscaCabecalho,
]

export const emitter = mitt();


